import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Button } from 'primeng/button';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'kost-data-import-new-upload-artifacts',
  template: `
    <div>
      <h2 i18n>Erzeugte Dateien</h2>
    </div>
    <p-table [value]="artifacts">
      <ng-template #header>
        <tr>
          <th i18n>Datei</th>
          <th i18n>Speichern</th>
        </tr>
      </ng-template>
      <ng-template #body let-artifact>
        <tr>
          <td>{{ artifact.displayName }}</td>
          <td>
            <p-button
              icon="pi pi-download"
              severity="secondary"
              [text]="true"
              [rounded]="true"
              ariaLabel="Datei speichern"
              (onClick)="saveArtifact(artifact)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  `,
  styles: ``,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TableModule, Button],
})
export class KostDataImportNewUploadArtifactsComponent {
  @Input()
  public artifacts: { content: Blob; displayName: string }[];

  public saveArtifact(artifact: { displayName: string; content: Blob }): void {
    FileSaver.saveAs(artifact.content, artifact.displayName);
  }
}
